// import logo from './logo.svg';
import "./App.css";
import React, { useState, useEffect } from "react";
// import Navbar from './components/Navbar';
// import Footer from './components/Footer';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
// import Register from './components/Register';
import Signup from "./Forms/Signup";
import PartnerReg from "./Forms/PartnerReg";
import Agreement from "./Forms/Agreement";
import Thankyou from "./Forms/Thankyou";
import Professionaldetails from "./Forms/Professionaldetails";
import Congrats from "./Forms/Congrats";
import Signin from "./Forms/Signin";
import Instruction from "./Forms/Instruction";
// import Instructions from './Forms/Instructions';
import Addreferral from "./Forms/Addreferral";
import Thankreferral from "./Forms/Thankreferral";
import Referraldetails from "./Forms/Referraldetails";
// import Partnerdashboard from "./Pages/Partnerdashboard";
import Mainlayout from "./PartnerDashboard/Layout/Mainlayout";
import EmployeeLayout from "./EmployeeDashboard/Layout/EmployeeLayout";
import Layout from "./components/Layout";
import Loginlayout from "./components/Loginlayout";
// import Otp from "./Forms/Otp";
import Emailpage from "./EmailPage/Emailpage";
import Verify from "./Forms/Verify";
import Forgotpassword from "./Forms/Forgotpassword";
import Resetpassword from "./ResetEmail/Resetpassword";
import Discussiondetails from "./EmployeeDashboard/Layout/Discussiondetails";
// import Appovepage from "./EmailPage/Appovepage";
import Approve from "./EmployeeDashboard/Approve";
import Reject from "./EmployeeDashboard/Reject";
// import Approve from "./EmployeeDashboard/Approve";
import SessionTimeoutWrapper from "./components/SessionTimeoutWrapper";
import InsuranceReg from "./Forms/InsuranceReg";
import InsSignin from "./Forms/InsuranceSignin";
import InsuranceSignup from "./Forms/InsuranceSignup";
import Dashboard from "./EmployeeDashboard/Layout/Dashboard";
import PartnersComponent from "./EmployeeDashboard/Layout/PartnersComponent";
import ReferralsPoints from "./EmployeeDashboard/Layout/ReferralsPart/ReferralsPoints";
import ManagementReferrals from "./EmployeeDashboard/Layout/ManagementReferrals";
import Leadmanagement from "./EmployeeDashboard/Layout/LeadsPart/Leadmanagement";
import ClientComponent from "./EmployeeDashboard/Layout/ClientsPart/ClientComponent";
import Insurance from "./EmployeeDashboard/Layout/Insurance";
import DroppedInt from "./EmployeeDashboard/Layout/DroppedInt";
import Interactionslist from "./EmployeeDashboard/Layout/Interactionslist";
import ManagersComponent from "./EmployeeDashboard/Layout/ManagersComponent";
import Notifications from "./EmployeeDashboard/Layout/Notifications";
import LeadFeatures from "./EmployeeDashboard/Layout/LeadsPart/LeadFeatures";
import EditLeadProfile from "./EmployeeDashboard/Layout/LeadsPart/EditLeadProfile";
import LeadInteraction from "./EmployeeDashboard/Layout/LeadsPart/LeadInteraction";
import NewLeadInteraction from "./EmployeeDashboard/Layout/LeadsPart/NewLeadInteraction";
import AddNewLead from "./EmployeeDashboard/Layout/LeadsPart/AddNewLead";
import LeadsKyc from "./EmployeeDashboard/Layout/LeadsPart/LeadsKyc";
import ClientFeatures from "./EmployeeDashboard/Layout/ClientsPart/ClientFeatures";
import NewClientInteraction from "./EmployeeDashboard/Layout/ClientsPart/NewClientInteraction";
import EditClientProfile from "./EmployeeDashboard/Layout/ClientsPart/EditClientProfile";
import ClientInteraction from "./EmployeeDashboard/Layout/ClientsPart/ClientInteraction";
import ClientsKyc from "./EmployeeDashboard/Layout/ClientsPart/ClientsKyc";
import AddNewClient from "./EmployeeDashboard/Layout/ClientsPart/AddNewClient";
import IncompleteKycClients from "./EmployeeDashboard/Layout/ClientsPart/IncompleteKycClients";
import ReferralsFeatures from "./EmployeeDashboard/Layout/ReferralsPart/ReferralsFeatures";
import NewReferralInt from "./EmployeeDashboard/Layout/ReferralsPart/NewReferralInt";
import EditReferralProfile from "./EmployeeDashboard/Layout/ReferralsPart/EditReferralProfile";
import ReferralsKyc from "./EmployeeDashboard/Layout/ReferralsPart/ReferralsKyc";
import AddNewReferral from "./EmployeeDashboard/Layout/ReferralsPart/AddNewReferral";
import ClientOnbKyc from "./EmployeeDashboard/Layout/ClientsPart/ClientOnbKyc";
import AddBusinessNo from "./EmployeeDashboard/Layout/ClientsPart/AddBusinessNo";
import ViewBusinessNo from "./EmployeeDashboard/Layout/ClientsPart/ViewBusinessNo";
const Routerfile = () => {
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const [data, setData] = useState(null);
  // const [isLoggedIn, setIsLoggedIn] = useState(() => {
  //   const storedValue = localStorage.getItem("isLoggedIn");
  //   return storedValue === "true";
  // });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  // useEffect(() => {
  //   if (isLoggedIn) {
  //     localStorage.setItem("isLoggedIn", "true");
  //   } else {
  //     localStorage.removeItem("isLoggedIn");
  //   }
  // }, [isLoggedIn]);

  // const handleLogin = () => {
  //   setIsLoggedIn(true);
  //   localStorage.setItem("isLoggedIn", "true");
  // };

  // const handleLogout = () => {
  //   setIsLoggedIn(false);
  //   localStorage.removeItem("isLoggedIn");
  // };
  useEffect(() => {
    // Read from localStorage after component mounts
    const storedValue = localStorage.getItem("isLoggedIn");
    setIsLoggedIn(storedValue === "true");
    setIsInitialized(true); // Mark as initialized
  }, []);

  useEffect(() => {
    if (isInitialized) {
      // Only update localStorage after initialization
      if (isLoggedIn) {
        localStorage.setItem("isLoggedIn", "true");
      } else {
        localStorage.removeItem("isLoggedIn");
      }
    }
  }, [isLoggedIn, isInitialized]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  if (!isInitialized) {
    return null;
  }
  return (
    <div>
      <SessionTimeoutWrapper onLogout={handleLogout} isActive={isLoggedIn}>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Signup />
              </Layout>
            }
          />
          <Route
            path="/insurance-signup"
            element={
              <Layout>
                <InsuranceSignup />
              </Layout>
            }
          />
          <Route
            path="/register"
            element={
              <Layout>
                <PartnerReg setdata={setData} />
              </Layout>
            }
          />
          <Route
            path="/insurance-register"
            element={
              <Layout>
                <InsuranceReg setdata={setData} />
              </Layout>
            }
          />
          <Route
            path="/verify"
            element={
              <Layout>
                <Verify />
              </Layout>
            }
          />
          <Route
            path="/agreement"
            element={
              <Layout>
                <Agreement isdata={data} />
              </Layout>
            }
          />
          <Route
            path="/forgotpassword"
            element={
              <Layout>
                <Forgotpassword />
              </Layout>
            }
          />
          <Route
            path="/resetpassword/:token"
            element={
              <Layout>
                <Resetpassword />
              </Layout>
            }
          />
          <Route
            path="/thankyou"
            element={
              <Layout>
                <Thankyou />
              </Layout>
            }
          />
          <Route
            path="/professionaldetails"
            element={
              <Layout>
                <Professionaldetails />
              </Layout>
            }
          />
          <Route
            path="/congrats"
            element={
              <Layout>
                <Congrats />
              </Layout>
            }
          />
          <Route
            path="/signin"
            element={
              <Layout>
                <Signin onLogin={handleLogin} isdata={data} />
              </Layout>
            }
          />
          <Route
            path="/insurance-signin"
            element={
              <Layout>
                <InsSignin onLogin={handleLogin} isdata={data} />
              </Layout>
            }
          />
          <Route
            path="/instruction"
            element={
              <Loginlayout>
                <Instruction />
              </Loginlayout>
            }
          />
          <Route
            path="/addreferral"
            element={
              <Loginlayout>
                <Addreferral />
              </Loginlayout>
            }
          />
          <Route
            path="/thank"
            element={
              <Loginlayout>
                <Thankreferral />
              </Loginlayout>
            }
          />
          <Route
            path="/referraldetails"
            element={
              <Loginlayout>
                <Referraldetails />
              </Loginlayout>
            }
          />
          <Route
            path="/dashboard/*"
            element={
              isLoggedIn ? (
                <DashboardRoutes />
              ) : (
                <Navigate to="/signin" replace />
              )
            }
          />
          <Route
            path="/employeedashboard/approve/:token"
            element={<Approve />}
          />
          <Route path="/employeedashboard/reject/:token" element={<Reject />} />
          {/* <Route
            path="/employeedashboard/*"
            element={
              isLoggedIn ? (
                <EmployeeDashboard />
              ) : (
                <Navigate to="/signin" replace />
              )
            }
          /> */}
          <Route
            path="/employeedashboard/*"
            element={
              isLoggedIn ? (
                <EmployeeDashboard />
              ) : (
                <Navigate to="/signin" replace />
              )
            }
          />
          <Route path="/emailverify/:token" element={<Emailpage />} />
          <Route path="/discussiondetails" element={<Discussiondetails />} />
        </Routes>
      </SessionTimeoutWrapper>
    </div>
  );
};

const DashboardRoutes = () => (
  <>
    <Mainlayout />
  </>
  // <Routes>
  //   <Route path="/" element={<Mainlayout />}>
  //     <Route index element={<Dashboard setSelectedComponent={() => {}} />} />
  //     <Route path="partners" element={<PartnersComponent />} />
  //     <Route path="referrals" element={<ReferralsPoints />} />
  //     <Route path="referrals/view" element={<ReferralsFeatures />} />
  //     <Route path="referrals/edit" element={<EditReferralProfile />} />
  //     <Route path="referrals/add-interaction" element={<NewReferralInt />} />
  //     <Route path="referrals/kyc" element={<ReferralsKyc />} />
  //     <Route path="referrals/add" element={<AddNewReferral />} />
  //     <Route path="manage-referrals" element={<ManagementReferrals />} />
  //     <Route path="leads" element={<Leadmanagement />} />
  //     <Route path="leads/view" element={<LeadFeatures />} />
  //     <Route path="leads/edit" element={<EditLeadProfile />} />
  //     <Route path="leads/interactions" element={<LeadInteraction />} />
  //     <Route path="leads/add-interaction" element={<NewLeadInteraction />} />
  //     <Route path="leads/kyc" element={<LeadsKyc />} />
  //     <Route path="leads/add" element={<AddNewLead />} />
  //     <Route path="clients" element={<ClientComponent />} />
  //     <Route path="clients/view" element={<ClientFeatures />} />
  //     <Route path="clients/edit" element={<EditClientProfile />} />
  //     <Route path="clients/interactions" element={<ClientInteraction />} />
  //     <Route
  //       path="clients/add-interaction"
  //       element={<NewClientInteraction />}
  //     />
  //     <Route path="clients/kyc" element={<ClientsKyc />} />
  //     <Route path="clients/add" element={<AddNewClient />} />
  //     <Route
  //       path="clients/incomplete-kyc-clients"
  //       element={<IncompleteKycClients />}
  //     />
  //     <Route path="interactions" element={<Interactionslist />} />
  //     <Route
  //       path="insurance"
  //       element={<Insurance setSelectedComponent={() => {}} />}
  //     />
  //     <Route path="dropped-leads" element={<DroppedInt />} />
  //     <Route path="wealth-advisors" element={<ManagersComponent />} />
  //     {/* <Route path="add-partner" element={<AddPartner />} />
  //     <Route path="add-referral" element={<AddReferral />} />
  //     <Route path="add-lead" element={<AddLead />} />
  //     <Route path="add-client" element={<AddClient />} />
  //     <Route path="incomplete-kyc" element={<IncompleteKYC />} />
  //     <Route path="add-interaction" element={<AddInteraction />} /> */}
  //     <Route path="upload-documents" element={<Notifications />} />
  //   </Route>
  // </Routes>
);

const EmployeeDashboard = () => (
  <Routes>
    <Route path="/" element={<EmployeeLayout />}>
      <Route index element={<Dashboard setSelectedComponent={() => {}} />} />
      <Route path="partners" element={<PartnersComponent />} />
      <Route path="referrals" element={<ReferralsPoints />} />
      <Route path="referrals/view" element={<ReferralsFeatures />} />
      <Route path="referrals/edit" element={<EditReferralProfile />} />
      <Route path="referrals/add-interaction" element={<NewReferralInt />} />
      <Route path="referrals/kyc" element={<ReferralsKyc />} />
      <Route path="referrals/add" element={<AddNewReferral />} />
      <Route path="manage-referrals" element={<ManagementReferrals />} />
      <Route path="leads" element={<Leadmanagement />} />
      <Route path="leads/view" element={<LeadFeatures />} />
      <Route path="leads/edit" element={<EditLeadProfile />} />
      <Route path="leads/interactions" element={<LeadInteraction />} />
      <Route path="leads/add-interaction" element={<NewLeadInteraction />} />
      <Route path="leads/kyc" element={<LeadsKyc />} />
      <Route path="leads/add" element={<AddNewLead />} />
      <Route path="clients" element={<ClientComponent />} />
      <Route path="clients/view" element={<ClientFeatures />} />
      <Route path="clients/edit" element={<EditClientProfile />} />
      <Route path="clients/interactions" element={<ClientInteraction />} />
      <Route
        path="clients/add-interaction"
        element={<NewClientInteraction />}
      />
      <Route path="clients/kyc" element={<ClientsKyc />} />
      <Route path="clients/add-business-numbers" element={<AddBusinessNo />} />
      <Route path="clients/business-numbers" element={<ViewBusinessNo />} />
      <Route path="clients/add" element={<AddNewClient />} />
      <Route
        path="clients/incomplete-kyc-clients"
        element={<IncompleteKycClients />}
      />
      <Route path="interactions" element={<Interactionslist />} />
      <Route
        path="insurance"
        element={<Insurance setSelectedComponent={() => {}} />}
      />
      <Route path="dropped-leads" element={<DroppedInt />} />
      <Route path="wealth-advisors" element={<ManagersComponent />} />
      <Route path="client-onb-kyc" element={<ClientOnbKyc />} />
    </Route>
  </Routes>
);
// const EmailDashboard = () => (
//   <>
//     <Emailpage/>
//     {/* You can add additional components specific to the dashboard if needed */}
//   </>
// );

export default Routerfile;
